import moment from "moment";
import numeral from "numeral";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import { serializeObjToQueryParams } from "../utils";

import Statistics from "../apis/Statistics";

const momentTimezone = require("moment-timezone");

const statistics = {
    data()
    {
        return {
            error: false,
            loading: false,
            warning: false,

            dateRange: "day",
            selectedDomains: [],

            groupBySelectValue: [],
            exportFormat: "select",

            shwFilePopUp: false,
            chartLoader: false,
            fileLoading: false,
            failure: false,
            failureMessage: "",

            unsubsSeries: [],
            subsSeries: [],
            sendsSeries: [],
            clicksSeries: [],
            deliveriesSeries: [],
            totalsSeries: [],

            selectedTimezone: momentTimezone.tz.guess(),

            datePicker: [
                moment().subtract(1, "weeks").format("YYYY-MM-DD"),
                moment().subtract(1, "day").format("YYYY-MM-DD"),
            ],
        };
    },
    computed: {
        datePickerRangeText()
        {
            return this.datePicker.join(" ~ ");
        },
    },
    methods: {
        handleDataVariantUpdated(variant)
        {
            this.selectedDataVariant = variant;
        },
        formatNumber(number)
        {
            return Math.floor(Math.log10(Math.abs(number))) + 1 > 3 ? numeral(number).format("0.0a") : number;
        },
        getSum(arr, property, percentage = false)
        {
            if (!Array.isArray(arr)) {
                throw new Error("statistics: Invalid data provided. Must be an array.");
            }

            if (Array.isArray() && !arr.length) {
                console.error("statistics: Empty array provided.");

                return;
            }

            let sum = arr.reduce((acc, curr) =>
            {
                return curr[property] !== null ? acc + parseFloat(curr[property]) : acc;
            }, 0);

            return percentage ? sum.toFixed(2) : sum;
        },
        modifyDataForCreatingCharts(data, property, name, isDateTypeHour = false)
        {
            if (!Array.isArray(data)) {
                throw new Error("statistics: Invalid data provided. Must be an array.");
            }

            if (Array.isArray() && !data.length) {
                console.error("statistics: Empty array provided.");

                return;
            }

            data = data.reduce((acc, curr, index) =>
            {
                if (index === 0) {
                    acc = {};
                    acc["name"] = name;


                    acc["data"] = [];
                }
                acc["data"].push({
                    //2024-02-22 00:00:00+02
                    //temp solution
                    //moment(curr["dtr"]).add(1, "day"
                    x: !isDateTypeHour ? curr["dtr"].split(" ")[0] : curr["dtr"],
                    y: curr[property],
                });

                return acc;
            }, {});

            return data;
        },
        modifyDataForCreatingChartsByFields({ data, property, name, axis, isDateTypeHour = false })
        {
            if (!Array.isArray(data)) {
                throw new Error("statistics: Invalid data provided. Must be an array.");
            }

            if (Array.isArray() && !data.length) {
                console.error("statistics: Empty array provided.");

                return;
            }

            data = data.reduce((acc, curr, index) =>
            {
                if (index === 0) {
                    acc = {};
                    acc["name"] = name;


                    acc["data"] = [];
                }
                acc["data"].push({
                    //2024-02-22 00:00:00+02
                    //temp solution
                    //moment(curr["dtr"]).add(1, "day"
                    x: !isDateTypeHour ? curr[axis.x].split(" ")[0] : axis.x,
                    y: curr[property],
                });

                return acc;
            }, {});

            return data;
        },
        getEventsByDripId(date_start, date_end, date, type, limit = 100000, offset = 0)
        {
            let responseArray = [];

            return new Promise((resolve, reject) =>
            {
                let domainId = this.$route.params.id ? `&domain_ids=${this.$route.params.id}` : "";
                let divideByParams =
                    this.groupBySelectValue !== "select" &&
                        this.groupBySelectValue !== "default"
                        ? `&group_by=type,${this.groupBySelectValue}`
                        : `&group_by=type`;

                Statistics.getStatsEventsByDrips(
                    `date_start=${date_start}&date_finish=${date_end}&date_trunc=${date}&offset=${offset}&limit=${limit}` + divideByParams + domainId
                )
                    .then((response) =>
                    {
                        return response.data.data;
                    })
                    .then((response) =>
                    {
                        responseArray.push(JSON.parse(JSON.stringify(response)));


                        if (response.length === limit) {
                            this.getEventsByDripId(date_start, date_end, date, type, limit, ++offset);
                        } else if (response.length < limit) {
                            responseArray = responseArray.flat(2);
                            resolve(responseArray);
                        }
                    })
                    .catch((error) =>
                    {
                        this.error = error;
                        reject(error);
                    });
            });
        },
        getDripStatsFile(dateStart = null, dateEnd = null, cache, date, type)
        {
            let dateParams = dateStart
                ? `date_start=${dateStart}&date_finish=${dateEnd}`
                : "";
            let dateTruncParams = date ? `&date_trunc=${date}` : "";
            let dripTypeParams = type
                ? `&drip_type=${type}`
                : "";
            let domainIdParams = `&domain_ids=${this.selectedDomains.toString()}`;
            let divideByParams =
                this.groupBySelectValue !== "select" &&
                    this.groupBySelectValue !== "default"
                    ? `&group_by=type,${this.groupBySelectValue}`
                    : `&group_by=type`;

            return new Promise((resolve, reject) =>
            {
                Statistics.getStatsEventsByDrips(
                    dateParams + dateTruncParams + dripTypeParams + domainIdParams + divideByParams + `&timezone=${this.selectedTimezone}`,
                    {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        cache: cache,
                        toFile: true,
                    }
                )
                    .then((response) =>
                    {
                        resolve(response);

                        setTimeout(() =>
                        {
                            this.shwFilePopUp = true;

                            //this.checkFileStatus();
                        }, 3500);
                    })
                    .catch((err) =>
                    {
                        reject(err);

                        if (err.response !== undefined && (err.response.status === 419 || err.response.status === 401)) {
                            this.logout().then(() =>
                            {
                                localStorage.removeItem("auth");
                                this.$route.replace({
                                    name: "Login",
                                    path: this.$route.path,
                                });
                            });
                        } else {
                            this.error = err;
                        }
                    })
                    .finally(() =>
                    {
                        this.fileInProgress = false;
                    });
            });
        },
        getSubsFile(dateStart = null, dateEnd = null, cache, date)
        {
            let dateParams = dateStart
                ? `date_start=${dateStart}&date_finish=${dateEnd}`
                : "";
            let dateTruncParams = date
                ? `&date_trunc=${date}`
                : "";
            let domainIdParams = `&domain_ids=${this.selectedDomains.toString()}`;

            return new Promise((resolve, reject) =>
            {
                Statistics.getStatsBySubscribables(dateParams + dateTruncParams + domainIdParams + `&timezone=${this.selectedTimezone}`, {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    cache: cache,
                    toFile: true
                })
                    .then((response) =>
                    {
                        resolve(response);

                        setTimeout(() =>
                        {
                            this.shwFilePopUp = true;

                            //this.checkFileStatus();
                        }, 3500);
                    })
                    .catch((err) =>
                    {
                        reject(err);

                        if (err.response !== undefined && (err.response.status === 419 || err.response.status === 401)) {
                            this.logout().then(() =>
                            {
                                localStorage.removeItem("auth");
                                this.$route.replace({
                                    name: "Login",
                                    path: this.$route.path,
                                });
                            });
                        } else {
                            this.error = err;
                        }
                    })
                    .finally(() =>
                    {
                        this.fileInProgress = false;
                    });
            });
        },
        downloadFile()
        {
            let postParams = {
                date_start: moment(this.datePicker[0]).format("YYYY-MM-DD"),
                date_finish: moment(this.datePicker[1]).format("YYYY-MM-DD"),
                date_trunc: this.dateRange,
                domain_ids: this.selectedDomains.toString(),
                //group_by: this.groupBySelectValue.toString(),
                timezone: this.selectedTimezone
            };
            console.log("🚀 ~ postParams:", postParams)
            let headers = {
                "Content-Type": "application/json",
                Accept: "application/json",
                cache: 3600,
                toFile: true,
            };

            console.log(Array.isArray(this.groupBySelectValue) && !this.groupBySelectValue.length)

            if (Array.isArray(this.groupBySelectValue) && this.groupBySelectValue.length) {
                postParams.group_by = this.groupBySelectValue.toString();
            }

            this.fileInProgress = true;

            if (this.selectedDataVariant === "subs") {
                //this.getSubsFile(moment(this.datePicker[0]).format("YYYY-MM-DD"), moment(this.datePicker[1]).format("YYYY-MM-DD"), 0, this.dateRange);
                Statistics.getStatsBySubscribablesPost(postParams, headers);
            } else if (this.selectedDataVariant === "drips") {
                Statistics.getStatsEventsByDripsPost(postParams, headers);
                //this.getDripStatsFile(moment(this.datePicker[0]).format("YYYY-MM-DD"), moment(this.datePicker[1]).format("YYYY-MM-DD"), 0, this.dateRange);
            } else if (this.selectedDataVariant === "errors") {
                //let serializeObj = serializeObjToQueryParams(postParams);
                //console.log("🚀 ~ serializeObj:", serializeObj)

                Statistics.getStatsPushErrorsPostParams(postParams, headers);
            }
        },
    },
    watch: {
        async "$route.params.id"(id)
        {
            this.loading = true;
            await this.resetValues();
            await this.resetSeries();

            await this.getInitialStats();

            this.$nextTick(() =>
            {
                this.loading = false;
            });
        },
        datePicker(date)
        {
            if (this.$route.name !== "Compare" && this.$route.name !== "Files") {
                this.loading = true;

                setTimeout(() =>
                {
                    this.loading = false;
                }, 1000);
            }
        },
    }
};

export default statistics;